import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { get } from 'lodash'

import { routing, parkingLots } from '../redux'

import ParkingLotsList from '../components/ParkingLotsList'
import ParkingLotDetails from '../components/ParkingLotDetails'
import ParkingLotBasicInfoForm from '../components/ParkingLotBasicInfoForm'

const ParkingLotsContainer = ({ item, id, tab }) => {
    if (tab === 'add') {
        return <ParkingLotBasicInfoForm initialValues={ parkingLots.createDefaultPayload() } />
    }

    if (id) {
        return <ParkingLotDetails item={ item } />
    }

    return <ParkingLotsList dataSelector={ parkingLots.getForCurrentUser } />
}

ParkingLotsContainer.propTypes = {
    item : PropTypes.object,
    tab  : PropTypes.string,
    id   : PropTypes.string
}

function mapStateToProps(state, ownProps) {
    return {
        tab  : get(ownProps, 'params.tab'),
        id   : get(ownProps, 'params.id'),
        item : parkingLots.getForID(get(ownProps, 'params.id'))(state)
    }
}

export default compose(
    routing.withRouter,
    connect(mapStateToProps)
)(ParkingLotsContainer)
